/** Job status -> MUI chip colour, shared by the portal's list and detail views. */
export const PORTAL_JOB_STATUS_COLOR: Record<
  string,
  'default' | 'info' | 'warning' | 'success' | 'error'
> = {
  P: 'default',
  IP: 'info',
  FV: 'warning',
  FI: 'warning',
  F: 'success',
};

/**
 * Job status -> the icon shown beside its chip. Keeps the colour and the shape
 * saying the same thing, so the status is readable without relying on colour
 * alone.
 */
export const PORTAL_JOB_STATUS_ICON: Record<string, 'pending' | 'progress' | 'review' | 'done'> = {
  P: 'pending',
  IP: 'progress',
  FV: 'review',
  FI: 'review',
  F: 'done',
};
